import React from "react";
import { useLang } from "@/context/LanguageContext";
import { useSeo } from "@/lib/api";
import { site } from "@/config/site";
import { Section, Reveal, Eyebrow } from "@/components/common/Section";
import Breadcrumb from "@/components/common/Breadcrumb";
import FinalCta from "@/components/common/FinalCta";

export default function Partners() {
  const { t, lang } = useLang();
  useSeo({ lang, path: "/partenaires", title: `${t.footer.links.partners.label} — NEKASSUR`, description: t.partners.intro });

  return (
    <>
      <section className="bg-nek-navy">
        <div className="nek-container py-12 sm:py-16">
          <Breadcrumb onDark items={[{ label: t.footer.links.partners.label }]} />
          <Reveal className="mt-8 max-w-3xl">
            <Eyebrow className="!text-nek-teal-100">{t.partners.eyebrow}</Eyebrow>
            <h1 className="nek-h1 mt-4 text-white" style={{ fontSize: "clamp(2.2rem,4vw,3.4rem)" }}>{t.partners.title}</h1>
            <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/70">{t.partners.intro}</p>
          </Reveal>
        </div>
      </section>

      <Section tone="white">
        <Reveal className="mx-auto max-w-3xl rounded-[20px] bg-nek-navy p-10 text-center sm:p-14">
          <p className="font-heading text-6xl font-extrabold text-nek-teal-100 sm:text-7xl">{site.partnerNetwork.count}</p>
          <p className="mt-3 font-heading text-xl font-bold text-white">{t.partners.networkLabel}</p>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-white/70">{t.partners.note}</p>
        </Reveal>
      </Section>

      <FinalCta />
    </>
  );
}
